import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { submitCallbackRequest } from "../../../../store/callbackRequest/actions/submitCallbackRequest";
import { getAddress } from "../../../../store/common/actions/getAddress";
import { ERROR_TYPES } from "../../../../store/constants";
import { CHECK_HOUSE_CONNECTION_STATUS, popupSteps } from "../../../../store/common/constants";
import { mapResponseStatusOnStep } from "../../../../store/common/utils";
import { checkConnectionAndTariffsInPopup } from "./actions/checkConnectionAndTariffsInPopup";
var initialState = {
  isOpen: false,
  currentStep: popupSteps.addressRequestForm,
  status: CHECK_HOUSE_CONNECTION_STATUS.CheckAddress,
  addressSuggestions: [],
  isError: false,
  isCheckboxError: false,
  isLoading: false,
  selectedAddress: null,
  isAddressError: false,
  tariffData: undefined,
  popupData: undefined,
  tariffType: undefined,
  region: undefined,
  houseInacId: undefined
};
export var checkAddressInlineSlice = createSlice({
  name: 'orderTariffFormPopup',
  initialState: initialState,
  reducers: {
    setIsOpen: function setIsOpen(state) {
      state.isOpen = !state.isOpen;
    },
    setHouseInacId: function setHouseInacId(state, _ref) {
      var payload = _ref.payload;
      state.houseInacId = payload;
    },
    setOrderTariffType: function setOrderTariffType(state, _ref2) {
      var payload = _ref2.payload;
      state.tariffType = payload;
    },
    setStatus: function setStatus(state, _ref3) {
      var payload = _ref3.payload;
      state.status = payload;
    },
    setAlternativeTariff: function setAlternativeTariff(state, _ref4) {
      var payload = _ref4.payload;
      state.tariffData = payload;
    },
    setIsCheckboxError: function setIsCheckboxError(state, _ref5) {
      var payload = _ref5.payload;
      state.isCheckboxError = payload;
    },
    resetInlineStepsData: function resetInlineStepsData(state) {
      state.tariffData = undefined;
      state.currentStep = popupSteps.addressRequestForm;
      state.selectedAddress = null;
      state.isCheckboxError = false;
      state.isAddressError = false;
      state.status = CHECK_HOUSE_CONNECTION_STATUS.CheckAddress;
    },
    setSelectedAddress: function setSelectedAddress(state, _ref6) {
      var payload = _ref6.payload;
      state.selectedAddress = payload;
    },
    setIsAddressErrorStatus: function setIsAddressErrorStatus(state, _ref7) {
      var payload = _ref7.payload;
      state.isAddressError = payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getAddress.fulfilled, function (state, _ref8) {
      var payload = _ref8.payload;
      state.addressSuggestions = payload;
      if (!payload.length) {
        state.isAddressError = true;
        state.status = CHECK_HOUSE_CONNECTION_STATUS.NotFound;
      }
    }).addCase(getAddress.rejected, function (state, _ref9) {
      var payload = _ref9.payload;
      state.isAddressError = !(payload === ERROR_TYPES.cancel);
    }).addCase(checkConnectionAndTariffsInPopup.fulfilled, function (state, _ref10) {
      var payload = _ref10.payload;
      var connectionStatus = payload.connectionStatus,
        isRedirect = payload.isRedirect,
        houseInacId = payload.houseInacId;
      if (isRedirect) return;
      state.isLoading = false;
      if (![CHECK_HOUSE_CONNECTION_STATUS.IsAvailable, CHECK_HOUSE_CONNECTION_STATUS.CheckAddress].includes(connectionStatus)) {
        state.isAddressError = true;
      }
      var status = mapResponseStatusOnStep(connectionStatus);
      if (!Object.values(CHECK_HOUSE_CONNECTION_STATUS).includes(status)) {
        state.currentStep = popupSteps.fail;
        return;
      }
      if (status === CHECK_HOUSE_CONNECTION_STATUS.SpeedLimit) {
        state.tariffData = payload.tariff;
      }
      state.status = status;
      state.houseInacId = houseInacId;
    }).addCase(submitCallbackRequest.fulfilled, function (state, _ref11) {
      var payload = _ref11.payload;
      state.isLoading = false;
      if (payload.isSucceeded && !payload.isCaptchaError) {
        state.currentStep = popupSteps.shortSuccess;
      }
    }).addCase(checkConnectionAndTariffsInPopup.rejected, function (state, _ref12) {
      var payload = _ref12.payload;
      state.isLoading = false;
      state.isAddressError = true;
      if (payload === ERROR_TYPES.emptyAddress) {
        return;
      }
      state.status = CHECK_HOUSE_CONNECTION_STATUS.IsNotAvailable;
    }).addCase(submitCallbackRequest.rejected, function (state) {
      state.isLoading = false;
      state.currentStep = popupSteps.fail;
    }).addMatcher(isAnyOf(checkConnectionAndTariffsInPopup.pending, submitCallbackRequest.pending), function (state) {
      state.isLoading = true;
    });
  }
});
var _checkAddressInlineSl = checkAddressInlineSlice.actions,
  setSelectedAddress = _checkAddressInlineSl.setSelectedAddress,
  setHouseInacId = _checkAddressInlineSl.setHouseInacId,
  setIsAddressErrorStatus = _checkAddressInlineSl.setIsAddressErrorStatus,
  resetInlineStepsData = _checkAddressInlineSl.resetInlineStepsData,
  setIsCheckboxError = _checkAddressInlineSl.setIsCheckboxError,
  setStatus = _checkAddressInlineSl.setStatus;
export { setSelectedAddress, setHouseInacId, setIsAddressErrorStatus, resetInlineStepsData, setIsCheckboxError, setStatus };
export var checkAddressInlineReducer = checkAddressInlineSlice.reducer;